<template>
	<div>
		<v-toolbar dense class="rounded">
			<v-btn icon class="hidden-xs-only" @click="$router.push('/gametype')">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>

			<v-toolbar-title>Limites y Pagos</v-toolbar-title>

			<v-spacer></v-spacer>
		</v-toolbar>

		<div class="mt-3 rounded white pa-15 text-justify">
			<h1 class="main-title">TAR.LA – Límites de Apuestas y Pagos</h1>
<hr class="header-divider">

<div class="company-info">
  <p>Operador: Inversiones Track and Races, C.A.</p>
  <p>Sitio: <a href="https://tar.la" class="site-link">https://tar.la</a></p>
</div>

<h2 class="section-title">1. Introducción</h2>
<p class="section-text">Este documento establece los límites de apuesta por clasificación de cliente y los límites máximos de pago por deporte y grupo de competición aplicables en la plataforma TAR.LA.</p>

<h2 class="section-title">2. Clasificación de Jugadores</h2>
<p class="section-text">Los jugadores se clasifican en cuatro niveles de riesgo:</p>

<table class="data-table">
  <thead>
    <tr>
      <th>Nivel</th>
      <th>Clasificación</th>
      <th>Prematch Parlay</th>
      <th>Prematch Straight</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>D</td>
      <td>$300</td>
      <td>$600</td>
    </tr>
    <tr>
      <td>2</td>
      <td>C</td>
      <td>$450</td>
      <td>$900</td>
    </tr>
    <tr>
      <td>3</td>
      <td>B</td>
      <td>$675</td>
      <td>$1,350</td>
    </tr>
    <tr>
      <td>4</td>
      <td>A</td>
      <td>$1,012.50</td>
      <td>$2,025</td>
    </tr>
  </tbody>
</table>

<p class="section-text note-text">Usuarios nuevos comienzan con clasificación <strong class="highlight-text">Nivel D</strong>.</p>

<h2 class="section-title">3. Límites Live Betting</h2>
<p class="section-text note-text">Solo se permiten apuestas <strong class="highlight-text">Straight en vivo</strong>.</p>
<p class="section-text note-text">Live Parlays no están permitidos para ninguna clasificación.</p>
<p class="section-text">Límite Live Straight por nivel:</p>

<table class="data-table live-limits-table">
  <thead>
    <tr>
      <th>Nivel</th>
      <th>Live Straight</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>D</td>
      <td>$600</td>
    </tr>
    <tr>
      <td>C</td>
      <td>$900</td>
    </tr>
    <tr>
      <td>B</td>
      <td>$1,350</td>
    </tr>
    <tr>
      <td>A</td>
      <td>$2,025</td>
    </tr>
  </tbody>
</table>

<h2 class="section-title">4. Reglas de Exposición</h2>
<p class="section-text">Los límites aplican por línea o proposición individual. Las apuestas no se calculan de forma diaria.</p>
<p class="section-text">El sistema agregará todas las apuestas realizadas por un usuario en la misma línea. Cuando se alcance el límite correspondiente a su clasificación, no se aceptarán nuevas apuestas.</p>

<h2 class="section-title">5. Máximo de Selecciones por Parlay</h2>
<p class="section-text">El máximo número de selecciones permitidas en una apuesta combinada es de <strong class="highlight-text">10</strong>.</p>

<h2 class="section-title">6. Límites Máximos de Pago por Deporte</h2>
<p class="section-text">Los límites máximos de pago están definidos por deporte y clasificación de liga. Estos límites prevalecen sobre cualquier límite de apuesta del jugador.</p>

<h3 class="sport-title">Futbol</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>UEFA CHAMPIONS LEAGUE</li>
  <li>UEFA Champions League</li>
  <li>UEFA EUROPEAN LEAGUE</li>
  <li>UEFA Europa League</li>
  <li>UEFA CONFERENCE LEAGUE</li>
  <li>UEFA Conference League</li>
  <li>ALMANYA BUNDESLİGA</li>
  <li>Germany Bundesliga</li>
  <li>FRANSA LİGEU 1</li>
  <li>France Ligue 1</li>
  <li>İNGİLTERE PREMİER LİGİ</li>
  <li>ENGLISH PREMIER LEAGUE</li>
  <li>İSPANYA L LİGA</li>
  <li>SPAIN L LIGA</li>
  <li>İTALYA SERİE A</li>
  <li>ITALY SERIE A</li>
  <li>TÜRKİYE SÜPERLİG</li>
  <li>TURKEY SUPER LEAGUE</li>
  <li>HOLLANDA EREDİVİSİE</li>
  <li>Dutch Eredivisie</li>
  <li>PORTEKİZ PREMİER LİGİ</li>
  <li>PORTUGUESE PREMIER LEAGUE</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $20.000<br>Combinada / Parkey: $35.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $13.000</p>
</div>

<h4 class="group-title">2. GRUPO</h4>
<ul class="league-list">
  <li>ABD MLS</li>
  <li>USA Major League Soccer</li>
  <li>ALMANYA BUNDESLİGA 2</li>
  <li>Germany Bundesliga 2</li>
  <li>BELÇİKA PRO LİG</li>
  <li>Belgium Pro League</li>
  <li>BREZİLYA SERİE A</li>
  <li>Brazil Serie A</li>
  <li>FRANSA LİG 2</li>
  <li>France Ligue 2</li>
  <li>HIRVATİSTAN 1. LİGİ</li>
  <li>CROATIAN FIRST LEAGUE</li>
  <li>HOLLANDA EERSTEDİVİSE</li>
  <li>NETHERLANDS EERSTEDIVISIE</li>
  <li>İNGİLTERA CHAMPİONSHİP</li>
  <li>ENGLISH CHAMPIONSHIP</li>
  <li>İSPANYA 2.LİG</li>
  <li>SPAIN SECOND DIVISION</li>
  <li>İSKOÇYA PREMİER</li>
  <li>SCOTLAND PREMIER</li>
  <li>İSVEÇ ALLSVENSKAN</li>
  <li>SWEDEN ALLSVENSKAN</li>
  <li>İSVİÇRE SÜPER LİG</li>
  <li>SWISS SUPER LEAGUE</li>
  <li>DANİMARKA SÜPER LİG</li>
  <li>DENMARK SUPER LEAGUE</li>
  <li>ARJANTİN Primera Division</li>
  <li>ARGENTINA Primera Division</li>
  <li>COPA LIBERTADORES</li>
  <li>COPA SUDAMERICANA</li>
  <li>RECOPA SUDAMERICANA</li>
  <li>MEXICO LIGA MX</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $13.000<br>Combinada / Parkey: $20.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $8.000</p>
</div>

<h4 class="group-title">3. GRUPO</h4>
<ul class="league-list">
  <li>İTALYA SERİE B</li>
  <li>Italy Serie B</li>
  <li>POLONYA EKSTRAKLOSA</li>
  <li>Poland Ekstraklasa</li>
  <li>ROMANYA 1.LİG</li>
  <li>Romania Liga 1</li>
  <li>TFF 1.LİG</li>
  <li>TFF 1st League (Turkey)</li>
  <li>UEFA Youth League</li>
  <li>RUSYA PREMİERLİGİ</li>
  <li>RUSSIAN PREMIER LEAGUE</li>
  <li>GREEK SUPER LEAGUE</li>
  <li>JAPONYA J1</li>
  <li>JAPAN J1</li>
  <li>NORVEÇ ELİTESERİEN</li>
  <li>NORWAY ELITE SERIES</li>
  <li>ENGLISH PREMIER LEAGUE</li>
  <li>OUTRIGHTS</li>
  <li>WORLD</li>
  <li>COSTA RICA PRIMERA DIVISION</li>
  <li>ECUADOR SERIE A</li>
  <li>PARAGUAY PRIMERA DIVISION</li>
  <li>VENEZUELA PRIMERA DIVISION</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $8.000<br>Combinada / Parkey: $13.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $6.000</p>
</div>

<h4 class="group-title">4. GRUPO</h4>
<ul class="league-list">
  <li>China Super League</li>
  <li>Chilean Primera División</li>
  <li>URUGUAY Primera Division</li>
  <li>URUGUAY First Division</li>
  <li>KOLOMBİYA Primera A</li>
  <li>COLOMBIA Primera A</li>
  <li>PANAMA LIGA PROM</li>
  <li>PERU PRIMERA DIVISION</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $6.000<br>Combinada / Parkey: $8.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $4.000</p>
</div>

<h3 class="sport-title">Basketbol</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>NBA REGULAR SEASON</li>
  <li>NBA PLAY-IN</li>
  <li>NBA PLAY-OFFS</li>
  <li>NBA IN-SEASON TOURNAMENT</li>
  <li>EUROLEGUE</li>
  <li>SPAIN ABC LEAGUE</li>
  <li>AVUSTRALYA NBL</li>
  <li>FRANSA PRO A (LNB)</li>
  <li>ITALY SERIE A (LEGA)</li>
  <li>GERMANY BBL</li>
  <li>GREECE A1 LEGUE (GBC)</li>
  <li>OLYMPICS - MEN</li>
  <li>OLYMPICS - WOMEN</li>
  <li>NATİONAL TEAMS FIBA EUROBASKET</li>
  <li>NATİONAL TEAMS FIBA WORD CUP</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $15.000<br>Combinada / Parkey: $20.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $10.000</p>
</div>

<h4 class="group-title">2. GRUPO</h4>
<ul class="league-list">
  <li>EUROPE – EUROCUP</li>
  <li>TURKEY BSL (TÜRKİYE BASKETBOL SÜPER LİGİ)</li>
  <li>WNBA REGULAR SEASON</li>
  <li>WNBA PLAYOFFS</li>
  <li>ISRAELI PREMIER LEAGUE</li>
  <li>B.LEAGUE (JAPONYA)</li>
  <li>LIGA NACIONAL (ARJANTİN)</li>
  <li>TURKEY CUP</li>
  <li>TURKEY SUPER CUP</li>
  <li>ITALY CUP (COPPA ITALIA)</li>
  <li>ITALY SUPER CUP</li>
  <li>GREECE CUP</li>
  <li>GERMANY CUP</li>
  <li>KOREA REPUBLIC KBL</li>
  <li>SPAIN COPE DEL REY</li>
  <li>SPAIN SUPER COP</li>
  <li>OUTRIGHTS</li>
  <li>WORLD</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $10.000<br>Combinada / Parkey: $15.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $8.000</p>
</div>

<h3 class="sport-title">Tenis</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>Wimbledon Championships MEN's ingiltere (Grand Slam) ATP</li>
  <li>Wimbledon Championships WOMEN's ingiltere (Grand Slam) WTA</li>
  <li>Australian Open (Grand Slam) ATP</li>
  <li>Roland Garros (French Open) (Grand Slam) ATP</li>
  <li>US Open (Grand Slam) ATP</li>
  <li>ATP Finals</li>
  <li>Indian Wells Masters (ABD (ATP Masters 1000)</li>
  <li>Monte Carlo Masters Monako (ATP Masters 1000)</li>
  <li>Rome Masters (Internazionali d’Italia) İtalya (ATP Masters 1000)</li>
  <li>Cincinnati Masters ABD (ATP Masters 1000)</li>
  <li>Australian Open (Grand Slam) WTA 1000</li>
  <li>Roland Garros (French Open) (Grand Slam) WTA 1000</li>
  <li>US Open (Grand Slam) WTA 1000</li>
  <li>WTA Finals</li>
  <li>Madrid Open İspanya (WTA 1000)</li>
  <li>Miami Open WTA 1000</li>
  <li>ABD (WTA 1000)</li>
  <li>Indian Wells Open ABD (WTA 1000)</li>
  <li>Rome Open (Internazionali d’Italia) İtalya (WTA 1000)</li>
  <li>China Open (Beijing) Çin (WTA 1000)</li>
  <li>ITF Davis Cup</li>
  <li>ITF Billie Jean King Cup</li>
  <li>United Cup (KARMA)</li>
  <li>Cincinnati Masters ABD (WTA Masters 1000)</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $20.000<br>Combinada / Parkey: $35.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $10.000</p>
</div>

<h3 class="sport-title">Buz Hokeyi</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>IHF MEN'S WORD CHAMPIONSHIP</li>
  <li>NHL- NATIONAL HOCKEY LEAGUE ( ABD-KANADA)</li>
  <li>KHL-KONTİNENTAL HOCKEY LEAGUE (RUSYA+AVRUPA SÜPERLİĞİ)</li>
  <li>SHL-SWEDİSH HOCKEY (İSVEÇ)</li>
  <li>NL-NATIONAL LEAGUE (İSVİÇRE)</li>
  <li>IHF WOMEN'S WORD CHAMPIONSHIP</li>
  <li>ZhHL – Zhenskaya Hockey League (RUSYA)</li>
  <li>OHL CANADA</li>
  <li>OUTRIGHTS</li>
  <li>WORLD</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $6.000<br>Combinada / Parkey: $10.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $6.000</p>
</div>

<h3 class="sport-title">BASEBALL</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>USA MLB</li>
  <li>USA NCAA</li>
  <li>OUTRIGHTS</li>
  <li>WORLD</li>
  <li>JAPON NPB</li>
  <li>COREA DEL SUR KBO</li>
  <li>MEXICO LMB</li>
  <li>VENEZUELA LVBP</li>
  <li>REPUBLICA DOMINICANA LIDOM</li>
  <li>Clásico Mundial de Béisbol</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $20.000<br>Combinada / Parkey: $35.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $13.000</p>
</div>

<h3 class="sport-title">FUTBOL AMERICANO</h3>

<h4 class="group-title">1. GRUPO</h4>
<ul class="league-list">
  <li>CANADA CFL</li>
  <li>USA NFL</li>
  <li>USA NCAAF</li>
</ul>
<div class="payout-limits">
  <p class="limit-header"><strong>LIMITE DE PAGO MAXIMO PARA ESTA CLASIFICACION:</strong></p>
  <p><strong>Prematch</strong><br>Derecha: $20.000<br>Combinada / Parkey: $35.000</p>
  <p><strong>Live/ En Vivo</strong><br>Derecha: $13.000</p>
</div>

<h2 class="section-title">7. Prioridad de Límites</h2>
<p class="section-text">Independientemente de la clasificación del jugador, el pago máximo de cualquier apuesta no podrá exceder el límite máximo definido para el deporte y grupo correspondiente.</p>
<p class="section-text">En caso de que el pago potencial supere dicho límite, el sistema ajustará automáticamente el pago al máximo permitido.</p>

<h2 class="section-title">8. Derecho del Operador</h2>
<p class="section-text">TAR.LA se reserva el derecho de limitar apuestas, modificar límites o rechazar apuestas cuando se considere necesario para la gestión del riesgo.</p>

	</div>
	</div>


</template>

<script>
export default {

}
</script>

<style>
.p { background-color: #FFF; }
.tabl {
	border: 1px solid #c0c0c0;
	border-collapse: collapse;
	padding: 5px;
	background: white;
	color: black;
	border-radius: 4px !important;
	width: 100%;
}
.tabd {
	border: 1px solid #c0c0c0;
	border-collapse: collapse;
	padding: 10px;
	background: white;
	color: black;
	border-radius: 4px !important;
	width: 100%;
}
.tabl th {
	border: 1px solid #c0c0c0;
	padding: 5px;
	border-radius: 4px !important;
	font-size: 12px !important;
}
.tabl td {
	border: 1px solid #c0c0c0;
	padding: 5px;
	border-radius: 4px !important;
}
</style>